import React, { Component } from 'react'
import { connect } from 'react-redux'
import avatar from '../../../../assets/Images/allStudentDetail1.png'
import { IoMdAddCircle } from 'react-icons/io';
import Select from 'react-select'
import { Form, FormControl, InputGroup } from "react-bootstrap";

import BackButton from '../../../../elements/BackButton'
// import Button from "react-bootstrap/Button";
import ContentLoader from 'react-content-loader';
import { getParentProfile, editParentProfile  } from "../../../../redux/Parent/user/action";


export class ParentEdit extends Component {
    state = {
        loading: false,
        parent:{}

    }

    componentDidMount() {
        this.setState({ loading: true });
        this.props.getParentProfile(this.props.parent.data.auth_token).then((response) => {
            // console.log(response)
            // if(response && response.payload && response.payload.success){
            this.setState({ loading: false, parent: response.payload.data });
            // }else{
            this.setState({ loading: false });
            //     console.log('API error')
            // }
        });
    }

    __changeProfileDetails=(data,key)=>{
        const details={...this.state.parent}
        details[key]=data
        this.setState({parent:details})
    }

    onSubmit = (e) => {
        e.preventDefault();
        const { user } = this.props;
        const { parent } = this.state;
        let formData = new FormData();
        formData.append('id',parent.id)
        formData.append("first_name", parent.first_name);
        formData.append("last_name", parent.last_name);
        // formData.append("image", parent.image);
        formData.append("email", parent.email);
        formData.append("phone", parent.phone);
        formData.append("date_of_birth", parent.date_of_birth);
        // formData.append("token", user.data.auth_token);
        // formData.append("image", parent.image)

        this.props.editParentProfile(formData).then((response) => {
            if (response) {
                if(response.data.success){
                    this.props.history.goBack()
                }

            }
        });
    };

    render() {
        // const options = [
        //     { value: 'chocolate', label: 'Chocolate' },
        //     { value: 'strawberry', label: 'Strawberry' },
        //     { value: 'vanilla', label: 'Vanilla' }
        // ]

        const customStyles = {
            option: (provided, state) => ({
                ...provided,
                backgroundColor: '#fff',
                border: 'none', // tried border: 'none'
                boxShadow: 'none', // tried border: 'none'
                outline: 'none',

            }),
            control: (provided) => ({
                ...provided,
                height: '45px',
                border: "none",
                boarderRadius: "10px",
                fontSize: '13px',
                borderStyle: 'none',
                backgroundColor: 'white',
                outline: 'none',
                boxShadow: "0px 3px 10px rgba(0, 0, 0, 0.1) inset",
                shadowOpacity: 0.5,
                shadowRadius: 50,

            }
            )

        }

        return (
            <React.Fragment>
                {this.state.loading ?
                    (
                        <React.Fragment>
                            <ContentLoader
                                viewBox="0 0 280 576"
                                backgroundColor={'#F3F3F3'}
                                foregroundColor={'#FFFFFF'}>
                                <circle cx="140" cy="100" r="40" />
                                <rect x="11" y="180" rx="0" ry="0" width="251" height="37" />
                                <rect x="11" y="250" rx="0" ry="0" width="251" height="37" />
                                <rect x="11" y="320" rx="0" ry="0" width="251" height="37" />
                                <rect x="11" y="390" rx="0" ry="0" width="251" height="37" />
                                <rect x="11" y="460" rx="0" ry="0" width="251" height="37" />
                            </ContentLoader>
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            <div className="position-relative">

                                <div className="edit-parent-bg">
                                    <div className='px-3 py-2'>
                                        <BackButton color="white" />
                                    </div>
                                </div>
                                <div className="position-absolute edit-parent-pic" style={{ boarderRadius: "30px 30px 0px 0px", }}>
                                    <div className='d-flex flex-row justify-content-center posititon-relative'>
                                        <div style={{ marginTop: '-40px' }}>
                                            <img className="profile-img-style p-2" src={avatar} alt="class-report" />
                                        </div>
                                        <div className="fs-5 position-absolute " style={{ marginTop: '5px', marginLeft: '80px', color: '#C34B6E' }}>
                                            <IoMdAddCircle />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        <Form onSubmit={this.onSubmit}>
                            <div className='px-2'>
                                <div className="position-relative px-2">
                                    <div className=" flex-column p-1">
                                        <span className="text-black ps-3">First Name:</span>
                                        <div className='profile-edit-form mt-2 pt-2 '>
                                            <input className='input-box-edit '
                                             placeholder='Enter your name'
                                             value={this.state.parent?.first_name}
                                             type="text"
                                             style={{ border: 'none', outline: 'none' }}
                                             onChange={(e)=>{this.__changeProfileDetails(e.target.value,'first_name')}}
                                             />
                                        </div>
                                    </div>
                                    <div className=" flex-column p-1">
                                        <span className="text-black ps-3">Last Name:</span>
                                        <div className='profile-edit-form mt-2 pt-2 '>
                                            <input className='input-box-edit '
                                             placeholder='Enter your name'
                                             value={this.state.parent?.last_name}
                                             type="text"
                                             style={{ border: 'none', outline: 'none' }}
                                             onChange={(e)=>{this.__changeProfileDetails(e.target.value,'last_name')}}
                                             />
                                        </div>
                                    </div>
                                    <div className="  flex-column p-1 ">
                                        <span className="text-black p-3">Email:</span>
                                        <div className='profile-edit-form mt-2 pt-2'>
                                            <input className=' input-box-edit' placeholder='Enter your email'
                                            value={this.state.parent?.email}
                                            type="email" style={{ border: 'none', outline: 'none' }}
                                            onChange={(e)=>{this.__changeProfileDetails(e.target.value,'email')}}
                                            />
                                        </div>
                                    </div>
                                    <div className=" flex-column p-1 ">
                                        <span className="text-black p-3">Phone:</span>
                                        <div className='profile-edit-form mt-2 pt-2'>
                                            <input className='input-box-edit ' placeholder='Enter your phone number'
                                             value={this.state.parent?.phone}
                                             type="tel" style={{ border: 'none', outline: 'none' }} minLength={10} maxLength={10} pattern="[6-9][0-9]{9}"
                                             onChange={(e)=>{this.__changeProfileDetails(e.target.value,'phone')}} title='Phone Number Should Start With [6-9] Max Length 10'
                                             />
                                        </div>
                                    </div>
                                    <div className=" flex-column p-1 ">
                                        <span className="text-black p-3">Date of birth:</span>
                                        <div className='profile-edit-form mt-2 pt-2'>
                                            <input className=' input-box-edit' placeholder='Enter your DOB'
                                            value={this.state.parent?.date_of_birth}
                                             type="dob" style={{ border: 'none', outline: 'none' }}
                                             onChange={(e)=>{this.__changeProfileDetails(e.target.value,'date_of_birth')}}
                                             />
                                        </div>
                                    </div>
                                    {/* <div className=" flex-column p-1">
                                        <span className="text-black p-3">Place:</span>
                                        <div className='profile-edit-form mt-2 pt-2'>
                                            <input className='input-box-edit ' placeholder='Enter your place' value={this.props.parent.data.name} type="name" style={{ border: 'none', outline: 'none' }} />
                                        </div>
                                    </div> */}
                                    {/* <div className=" flex-column p-1">
                                        <span className="text-black p-3">Class:</span>
                                        <div className='  pt-2 '>
                                            <Select className="text-muted" styles={customStyles} placeholder='Enter your class' options={options} />
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                            <div className=" d-grid gap-2 bg-white px-3 w-100 bottom-0 mt-4">
                                <button type='submit' className="edit-profile-btn">Submit</button>
                            </div>
                        </Form>
                        </React.Fragment>

                    )}
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => ({
        parent: state.user.parent,

})


export default connect(mapStateToProps,{ getParentProfile, editParentProfile })(ParentEdit)
